type WriteHandler = (data: string) => void;
type EndHandler = () => void;
type ThinkingHandler = (data: string) => void;
type ActivityHandler = (text: string) => void;

const writeHandlers = new Map<string, WriteHandler>();
const endHandlers = new Map<string, EndHandler>();
const thinkingHandlers = new Map<string, ThinkingHandler>();
const activityHandlers = new Map<string, ActivityHandler>();

export const terminalBridge = {
  register(
    id: string,
    onWrite: WriteHandler,
    onEnd: EndHandler,
    onThinking?: ThinkingHandler,
    onActivity?: ActivityHandler,
  ) {
    writeHandlers.set(id, onWrite);
    endHandlers.set(id, onEnd);
    if (onThinking) thinkingHandlers.set(id, onThinking);
    if (onActivity) activityHandlers.set(id, onActivity);
  },
  unregister(id: string) {
    writeHandlers.delete(id);
    endHandlers.delete(id);
    thinkingHandlers.delete(id);
    activityHandlers.delete(id);
  },
  write(id: string, data: string) {
    writeHandlers.get(id)?.(data);
  },
  writeThinking(id: string, data: string) {
    thinkingHandlers.get(id)?.(data);
  },
  /** Set the dynamic status-line phrase (e.g. "Reading foo.md") for the working line. */
  setActivity(id: string, text: string) {
    activityHandlers.get(id)?.(text);
  },
  endStream(id: string) {
    endHandlers.get(id)?.();
  },
};
